
import authenticate from '@auth/util'
import { CookiesModal } from '@legal/components/CookiesModal'
import BrazePrompt from '@tracking/braze/components/BrazePrompt.vue'

export default {
  components: {
    BrazePrompt,
    CookiesModal,
  },

  computed: {
    shouldRenderCookiesModalClientSide() {
      return this.$config.FF_COOKIES_MODAL_RENDERED_CLIENT_SIDE_IN_COUNTRY?.includes(
        this.country,
      )
    },
  },

  beforeMount() {
    authenticate({
      store: this.$store,
      config: this.$config,
    })
  },
}
